import clsx from 'clsx';

interface ShortcutLegendIconProps {
  shortcutCharacter: string | undefined;
  className?: string;
}

export const ShortcutLegendIcon = ({ shortcutCharacter, className }: ShortcutLegendIconProps) => {
  const deMacify = (char: string) => {
    if (navigator.platform.toUpperCase().indexOf('MAC') === -1) {
      return char.toLowerCase().replace('cmd', 'ctrl');
    }
    return char;
  };

  if (!shortcutCharacter) return null;

  return (
    <div
      className={clsx(
        className,
        'ml-3 px-1 min-w-[18px] capitalize w-auto h-[18px] border border-opacity-20 rounded border-darkMode-gray-medium text-darkMode-gray-medium text-xs inline-flex items-center justify-center'
      )}
    >
      {deMacify(shortcutCharacter)}
    </div>
  );
};
